import { z } from 'zod';
import { optionalTrimmedNullableString, requiredUuidString } from '../zod-helpers/index.js';
import { CAL_EVENT_CONTACT_CONSTRAINTS } from './constraints.js';
import { contactFieldsInputSchema } from './contact-fields-input.js';
import { hasContactField } from './has-contact-field.js';
export const addCalEventContactInputSchema = z
    .object({
    eventId: requiredUuidString('Event is required.', 'Invalid event ID.'),
    contactId: requiredUuidString('Invalid contact ID.', 'Invalid contact ID.').optional(),
    contact: contactFieldsInputSchema.optional(),
    note: optionalTrimmedNullableString(CAL_EVENT_CONTACT_CONSTRAINTS.note.maxLength, `Note must be ${CAL_EVENT_CONTACT_CONSTRAINTS.note.maxLength} characters or fewer.`),
    followUp: z.boolean().optional(),
})
    .superRefine((input, ctx) => {
    const hasContactId = input.contactId !== undefined;
    if (hasContactId === (input.contact !== undefined)) {
        ctx.addIssue({
            code: 'custom',
            message: 'Choose an existing contact or enter a new one.',
            path: ['contact'],
        });
        return;
    }
    if (input.contact && !hasContactField(input.contact)) {
        ctx.addIssue({ code: 'custom', message: 'Fill in at least one field.', path: ['contact'] });
    }
});
//# sourceMappingURL=add-cal-event-contact-input.js.map